import api from "../../store/api";
import _ from "lodash"
import { flatCustomers } from "./groupedItemHelpers";
import { ICustomer } from "./types/ICustomer";
import ISelectItem from "./types/ISelectItem"
import { setDataToStorage, getDataFromStorage } from "../../common/sessionStorageHelpers"

const filterCustomerForPopup = (locationState: any[],
    setSelectedCustomer: any,
    setSelectedLocations: any,
    persistName: string | null) => {
    const locations = locationState[0].filter((item: ISelectItem) => item.selected == true).map((item: ISelectItem) => item.value);
    const locationName = locationState[0].filter((item: ISelectItem) => item.selected == true).map((item: ISelectItem) => item.text);
    const selectedHospital = locationName.length == 1 ? locationName[0] : locationName.length > 1 ? `${locationName.length} Customers` : "All Customers";
    setSelectedCustomer(selectedHospital);
    if (persistName !== null) {
        setDataToStorage(persistName, "selectedCustomers", selectedHospital);
    }

    if (locations) {
        setSelectedLocations(locations);
        if (persistName !== null) {
            setDataToStorage(persistName, "selectedLocations", locations);
        }
    }
}
const getCustomerDataForPopup = async (customerState: any[],
    setSelectedCustomer: any,
    setSelectedLocations: any,
    selectedLocations: any,
    persistName: string | null,
    clusterId?: string | null): Promise<void> => {

    if (clusterId && persistName) {
        clusterId = null;
        console.error('Persistence and cluster filter are not supported together yet');
    }

    try {
        const res = await api.getCustomerGroupedByClusters('version='+Math.random().toString()+Math.random().toString()+Math.random().toString());
        const responseDataModel: ICustomer[] = res.data.model;
        let CustomerClusters: ISelectItem[] = flatCustomers(responseDataModel, selectedLocations);

        // if only one location => set it as filter
        if (responseDataModel.length === 1 && responseDataModel.length === 1) {
            const foundOneLocation = CustomerClusters.find(q => q.value === responseDataModel[0].customerId);
            if (foundOneLocation) {
                foundOneLocation.selected = true;
                if (persistName !== null) setDataToStorage(persistName, "selectedCustomers", foundOneLocation.text);
            }
        }

        customerState[1](CustomerClusters);

        const customer = CustomerClusters.filter((item: ISelectItem) => item.selected).map((item: ISelectItem) => item.value ?? "");
        if (customer && !_.isEqual(_.sortBy(customer), _.sortBy(selectedLocations))) {
            setSelectedLocations(customer);
        }

        if (customer.length === 1) {
            if (persistName !== null) setSelectedCustomer(getDataFromStorage(persistName, "selectedCustomers"));
        } else if (customer.length === 0) {
            setSelectedCustomer("All Customers");
            if (persistName !== null) setDataToStorage(persistName, "selectedCustomers", "All Customers");
        } else if (customer.length > 1) {
            setSelectedCustomer(`${customer.length} Customers`);
            if (persistName !== null) setDataToStorage(persistName, "selectedCustomers", `${customer.length} Customers`);
        }
    }
    catch (err) {
        setSelectedCustomer("All Customers");
        if (persistName !== null) setDataToStorage(persistName, "selectedCustomers", "All Customers");
    }
}

export {
    filterCustomerForPopup,
    getCustomerDataForPopup
}